export const GET_USER_BORROWS = 'GET_USER_BORROWS';
export const SET_USER_BORROWS = 'SET_USER_BORROWS';
export const SET_USER_BORROWS_SUSPENDED = 'SET_USER_BORROWS_SUSPENDED';
export const SET_USER_BORROWS_REGISTERED = 'SET_USER_BORROWS_REGISTERED';
export const SET_USER_BORROWS_CLOSED = 'SET_USER_BORROWS_CLOSED';
export const SET_USER_BORROWS_MAINTENANCE = 'SET_USER_BORROWS_MAINTENANCE';
export const SET_USER_BORROWS_MAINTENANCE_HISTORY = 'SET_USER_BORROWS_MAINTENANCE_HISTORY';
